import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { CommonModule } from '@angular/common';
import { SettingsService } from '../settings/settings.service';
import { CuentasBancarias } from '../info/ctas-bancarias/ctas/ctas';
import { CrearCuentaBancariaComponent } from '../info/ctas-bancarias/ctas/crear-cuenta-bancaria/crear-cuenta-bancaria.component';

@Component({
  selector: 'app-cuentas-bancarias-tubo',
  standalone: true,
  imports: [MaterialModule, CommonModule, CuentasBancarias, CrearCuentaBancariaComponent],
  templateUrl: './cuentas-bancarias-tubo.component.html',
  styleUrl: './cuentas-bancarias-tubo.component.less',
})
export class CuentasBancariasTuboComponent implements OnInit {
  tubos: any[] = [];
  selectedTuboId: number | null = null;
  selectedCompanyId: number | null = null;
  selectedTabIndex: number = 0;
  loading: boolean = true;
  actualizar: number = 0;

  constructor(private settings: SettingsService) {}

  async ngOnInit() {
    await this.getTubos();
    this.loading = false;
  }

  async getTubos() {
    try {
      const bd: any = await this.settings.get_query(1, '/cliente-inversionista/tubos/');
      this.tubos = bd._body.info.tubos;
      if (this.tubos.length > 0) {
        this.selectedTuboId = this.tubos[0].tubo_id;
        this.selectedCompanyId = this.tubos[0].company_id;
      }
    } catch (error) {
      console.error('Error al obtener tubos:', error);
      this.tubos = [];
    }
  }

  onTuboChange(index: number) {
    this.selectedTabIndex = index;
    this.selectedTuboId = this.tubos[index].tubo_id;
    this.selectedCompanyId = this.tubos[index].company_id;
  }

  procesaPropagar(event: number) {
    this.actualizar = event;
  }
}
